module.exports = __webpack_public_path__ + "img/activity3.a38197fb.png";